module.exports = __webpack_public_path__ + "media/images/homes/Info-25dde218e59c34d2d29e7f6b040517fb.svg";